import * as React from 'react';
export const arrowDownSvg = React.forwardRef(function arrowDownSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M1.381 9.619A.875.875 0 1 1 2.62 8.38l4.506 4.507V1a.875.875 0 1 1 1.75 0v11.888l4.506-4.507A.875.875 0 1 1 14.62 9.62l-6 6a.872.872 0 0 1-1.238 0l-6-6Z',
    }),
  );
});
arrowDownSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var arrowDown = {
  category: 'icon',
  colorable: true,
  name: 'arrowDown',
  svg: arrowDownSvg,
};
